import { render, staticRenderFns } from "./RegionListPage.vue?vue&type=template&id=13c9cc50"
import script from "./RegionListPage.ts?vue&type=script&lang=js&external"
export * from "./RegionListPage.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports